import React, { Component } from "react";
import "containers/Account/Onboarding/Onboarding.css";
import TextTheme from "components/General/Text/TextTheme";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import DefaultProfilePic from "site_media/images/default-profile-pic-feeds.png";
import AxiosConfig from "axiosConfig";

class MyInvatations extends Component {
  rejectGuardian = function (guardians) {
    let secondaryGuardian = guardians.primary_guardian.user_email;
    let formData = new FormData();
    formData.append("email", secondaryGuardian);
    AxiosConfig.put("guardian/reject_guardian/", formData, {});
  };

  acceptGuardian = function (guardians) {
    let secondaryGuardian = guardians.primary_guardian.user_email;
    let formData = new FormData();
    formData.append("email", secondaryGuardian);
    AxiosConfig.put("guardian/accept_guardian/", formData, {});
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "80%",
            paddingTop: "10px",
            paddingBottom: "10px",
            border: "solid #E3E3E3",
            marginBottom: "20px",
            borderRadius: 10,
            alignItems: "center",
          }}
        >
          <Image
            style={{
              width: "100px",
              height: "100px",
              borderRadius: 90,
              marginLeft: "20px",
            }}
            src={this.props.guardianImage || DefaultProfilePic}
          />

          <TextTheme
            message={this.props.guardianName}
            className="text_bold"
            styles={{
              textAlign: "center",
              marginLeft: "20px",
              fontSize: "15px",
            }}
          />
          <TextTheme
            message={`(${this.props.guardianEmail})`}
            className="text_bold"
            styles={{
              textAlign: "center",
              marginLeft: "10px",
              fontSize: "13px",
            }}
          />

          <span style={{ flex: 1 }}></span>
          <button className="btn btn-sm" style={{ marginRight: "25px" }}>
            <FontAwesomeIcon
              size="lg"
              icon={faCheck}
              color="green"
              onClick={() =>
                this.acceptGuardian(this.props.guardian, this.props.secGuardian)
              }
            />
          </button>
          <button className="btn btn-sm" style={{ marginRight: "25px" }}>
            <FontAwesomeIcon
              size="lg"
              icon={faTimes}
              color="red"
              onClick={() =>
                this.rejectGuardian(this.props.guardian, this.props.secGuardian)
              }
            />
          </button>
        </div>
      </div>
    );
  }
}

export default MyInvatations;
